const campaignStatuses = {
  opened: 'DC',
  closed: 'Closed',
  apn: 'RFQ',
};

export const mapCampaignStatus = (value: string | undefined): string =>
  campaignStatuses[value?.toLowerCase() as keyof typeof campaignStatuses] || value || '';
